// initial state
const state = {
  position: {},
  positions: [],
  statuses: {},
  trips: {},
}

// getters
const getters = {
  position: (state, getters, rootState) => {
    return state.position;
  },
  positions: (state, getters, rootState) => {
    return state.positions;
  },
  statuses: (state, getters, rootState) => {
    return state.statuses;
  },
  trips: (state, getters, rootState) => {
    return state.trips;
  },
}

// actions
const actions = {
  updatePositions({
    state,
    commit,
  }, payload) {
    commit('updatePositions', {
      position: payload.position
    });
  },
  removePositions({
    state,
    commit,
  }, payload) {
    commit('removePositions', {
      vehicleUid: payload.vehicleUid
    });
  },
  updateStatuses({
    state,
    commit,
  }, payload) {
    commit('updateStatuses', {
      status: payload.status
    });
  },
  updateTrips({
    state,
    commit,
  }, payload) {
    commit('updateTrips', {
      requestUid: payload.requestUid,
      trip: payload.trip
    });
  },
  destroyStorage({
    state,
    commit,
  }, payload) {
    commit('destroyStorage');
  },
}

// mutations
const mutations = {
  updatePositions(state, {
    position
  }) {
    if (Array.isArray(position)) {
      for (let i = 0; i < position.length; i++) {
        if (state.position[position[i].vehicleUid] == null) {
          state.position[position[i].vehicleUid] = {};
          state.positions[position[i].vehicleUid] = [];
        }

        state.position[position[i].vehicleUid] = position[i];
        state.positions[position[i].vehicleUid].push(position[i]);

        if (state.positions[position[i].vehicleUid] > 500)
          state.positions[position[i].vehicleUid].shift();
      }
      return;
    }

    if (typeof position == "object") {
      let isNew = false,
        hasChanged = false;
      if (state.position[position.vehicleUid] == null) {
        state.position[position.vehicleUid] = {};
        state.positions[position.vehicleUid] = [];
        isNew = true;
      }

      if (!isNew) {
        hasChanged = (state.position[position.vehicleUid].partners != position.partners) ||
          (state.position[position.vehicleUid].userUid != position.userUid) ||
          (state.position[position.vehicleUid].coordinates.lat != position.coordinates.lat) ||
          (state.position[position.vehicleUid].coordinates.lon != position.coordinates.lon) ||
          (state.position[position.vehicleUid].coordinates.bearing != position.coordinates.bearing);
      }
      state.position[position.vehicleUid] = position;
      state.position[position.vehicleUid]["hasChanged"] = hasChanged;
      state.positions[position.vehicleUid].push(position);

      if (state.positions[position.vehicleUid] > 500)
        state.positions[position.vehicleUid].shift();
      return;
    }
  },
  removePositions(state, {
    vehicleUid
  }) {
    if (vehicleUid in state.position) {
      delete state.position[vehicleUid];
      delete state.positions[vehicleUid];
    }
  },
  updateStatuses(state, {
    status
  }) {
    if (typeof status == "object") {
      let isNew = false,
        hasChanged = false;
      if (state.statuses[status.uid] == null) {
        state.statuses[status.uid] = {};
        isNew = true;
      }

      state.statuses[status.uid] = status;

      return;
    }
  },
  updateTrips(state, {
    requestUid,
    trip
  }) {
    state.trips[requestUid] = trip;
  },
  destroyStorage(state) {
    state.position = {};
    state.positions = [];
    state.statuses = {};
    state.trips = {};
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
